/**
 * @constant vehicle properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const vehicleProperties = [
  {
    label: 'vin',
    properties: ['vin']
  },
  {
    label: 'fleet-indicator',
    properties: ['fleetInd']
  },
  {
    label: 'generation',
    properties: ['generation']
  },
  {
    label: 'model-code',
    properties: ['model.modelCode', 'modelCode'],
  },
  {
    label: 'preferred-dealer',
    properties: ['preferredDealer'],
  },
  {
    label: 'home-dealer',
    properties: ['homeDealer'],
  },
  {
    label: 'dofu',
    properties: ['dateOfFirstUse']
  },
  {
    label: 'color',
    properties: ['color.colorDescription.english', 'color.colorDescription', 'color'],
  },
  {
    label: 'build-date',
    properties: ['manufacturedDate']
  },
  {
    label: 'region',
    properties: ['region']
  },
  {
    label: 'fuelType',
    properties: ['fuelType']
  },
  {
    label: 'electrical-platform',
    properties: ['electricalPlatformDescription']
  }

];
/**
 * @constant headUnit properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const headUnitProperties = [

  {
    label: 'head-unit-type',
    properties: ['headUnit.huVersion'],
    telematics: true
  },
  {
    label: 'mpc',
    properties: ['headUnit.mobilePlatformCode'],
    telematics: true
  },
  {
    label: 'head-unit',
    properties: ['headUnit.huDescription'],
    telematics: true
  },
  {
    label: 'head-generation',
    properties: ['headUnit.huGeneration'],
    telematics: true
  }
];
/**
 * @constant dcmInfo properties array, if the property is in a nested object, add the path of the property separated by '.'
 */
export const dcmInfoProperties = [
  {
    label: 'imei',
    properties: ['imei'],
    telematics: true
  },
  {
    label: 'manufacturer',
    properties: ['dcm.dcmSupplierName'],
    telematics: true
  },
  {
    label: 'dcm-model-year',
    properties: ['dcm.dcmModelYear'],
    telematics: true
  }
];

/**
* getFuelType converts fuelType from API to full form
* ex: input - B returns to  Electric & Gas Hybrid
**/
export function getFuelType(term): string {
  const fuelType = new Map<string, string>([
    ['B', 'Electric & Gas Hybrid'],
    ['C', 'Convertible'],
    ['D', 'Diesel'],
    ['E', 'Electric'],
    ['F', 'Flexible'],
    ['G', 'Gas'],
    ['H', 'Ethanol'],
    ['I', 'Plug-in Hybrid'],
    ['M', 'Methanol'],
    ['N', 'Compressed Natural Gas'],
    ['P', 'Propane'],
    ['R', 'Hydrogen Fuel Cell'],
    ['U', 'Unknown'],
    ['X', 'Gas & Oil Mix'],
    ['Y', 'Electric & Diesel Hybrid'],

  ]);
  return fuelType.get(term);
}
